import { FC, useCallback } from 'react'
import { GenericDialogLayout } from 'src/components/GenericDialogLayout'
import { permissionValue } from 'src/enums/permissionValue'
import { IComponent } from 'src/generated-types'
import { IDeviationType } from 'src/generated-types/deviation-type'
import { IMainComponent } from 'src/generated-types/main-component'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { ShowDialogProps } from 'src/show-dialog'
import DeviationTab from '../mainComponents/components/DeviationTab'
import { CreatePositionDeviationDialog } from './CreatePositionDeviationDialog'

interface DeviationContainerDialogProps extends ShowDialogProps {
  customerId: EntityId
  localityId: EntityId
  mainComponent?: IMainComponent
  maintenanceId?: number
  onAddDeviation?: () => void
  component?: IComponent
  insideNavigation?: boolean
  isWithDialog?: boolean
  deviationTypeFromParent: IDeviationType
}

export const DeviationContainerDialog: FC<DeviationContainerDialogProps> = ({
  customerId,
  localityId,
  mainComponent,
  maintenanceId,
  onAddDeviation,
  pop,
  component,
  insideNavigation,
  isWithDialog,
  deviationTypeFromParent,
}) => {
  const { showDialog } = useDialogCtx()

  const onAddDeviationForPosition = useCallback(async () => {
    if (insideNavigation) {
      pop('createDeviation')
    } else {
      await showDialog(
        CreatePositionDeviationDialog,
        {
          componentProps: {
            customerId: customerId as EntityId,
            localityId: localityId as EntityId,
            mainComponent: mainComponent,
            maintenanceId: maintenanceId,
            component: component,
            type: deviationTypeFromParent,
            disableSteps: true,
            deviationTypeFromParent: deviationTypeFromParent,
          },
        },
        undefined,
        true,
      )
    }
  }, [mainComponent, component])

  const Content = () => {
    return (
      <DeviationTab
        customerId={customerId as EntityId}
        localityId={localityId as EntityId}
        mainComponentId={mainComponent?.id as EntityId}
        componentId={component?.id as EntityId}
        onAddDeviationForComponent={onAddDeviation ?? onAddDeviationForPosition}
        queryParams={{ localityId }}
        addPermissions={[permissionValue.Locality.MainComponent.Deviation.Write]}
        updatePermissions={[permissionValue.Locality.MainComponent.Deviation.Write]}
        deletePermissions={[permissionValue.Locality.MainComponent.Deviation.Delete]}
        pop={pop}
        autoHeight={false}
        enablePagination={false}
        height={300}
        selectedLocalityId={localityId}
      />
    )
  }

  return isWithDialog ? (
    <GenericDialogLayout removedCloseButton={false} pop={pop}>
      <Content />
    </GenericDialogLayout>
  ) : (
    <Content />
  )
}
